module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAq0lEQVQokZWSKw4CQRBES3CMFXsvDKJ/B9gEOzfB7D0QCOQKxErkHgGBADOE7vmE0EmZ6a6ZV50BXJnZXkTuIvIq9FDVI8pi5nNjuClVvQIAisaiqqeWRGTxs8HIzFOF86WagjFnG4loyARbA/EJAEQ0mNlY3doxfbQ1UURkdUOrO/dbvgRTDh/5c6WUdsVWzb8WsJj50FtKuLiT6ZZV9X4Zu/IZ5z9+zgwAb+b9/81c/0QyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/images/icon_dh.png
// module id = vjEg
// module chunks = 2